// 产品介绍
<template>
  <div class="cpjs width1200">
    <div class="item-desc">
      <p class="text1">资源组成</p>
      <p class="text2">IP资源来源于全国各地的真实家宽用户。</p>
    </div>
    <!--<div class="item-desc">
      <p class="text1">与传统代理IP池的区别</p>
      <p class="text2">
        传统
        IP代理池：在地区所在机房接入对应数量的拨号线路，在软路由上多拨。一台边点设备对应多条同地区的拨号线路。通常这种拨号线路多为运营商单独划分的代理线路。这些代理线路对应的
        IP池污染程度极高，经常会被反爬程度高的目标站点风控。
      </p>
      <p class="text2">
        家庭住宅
        IP代理池：单一的出口IP对应一台设备（路由器、机顶盒、pad等），用户利用家庭空闲带宽跑边缘计算收取佣金。对应的是运营商的家用IP池，IP为真人家用IP。
      </p>
    </div>-->
    <img
      :src="require('@/assets/images/cpjs14.png')"
      alt=""
      class="cpjs-imgs w-100"
    />
    <div class="item-desc">
      <p class="text1">使用方式</p>
      <p class="text2">
        用户使用 API提取的方式，获取到分布式中心代理服务器的 IP
        以及代理端口。一个代理端口对应一个出口 IP。
      </p>
    </div>
    <div class="item-desc">
      <p class="text1">支持的协议</p>
      <p class="text2">HTTP、SOCKS5</p>
    </div>
    <div class="item-desc">
      <p class="text1">计费方式</p>
      <p class="text2">按 IP 提取量，提取了就开始计费。</p>
    </div>
    <div class="item-desc">
      <p class="text1">套餐介绍</p>
      <ul>
        <li>
          套餐按代理 IP 可用时长，分为 1 分钟、3 分钟、5 分钟、10
          分钟。代理端口到期自动关闭。
        </li>
        <li>提取最大提取量为 200,1秒钟内默认不超过 4 次提取。</li>
        <li>单条线路带宽 3Mbps左右。</li>
        <li>单条线路不限制并发，实际并发受边缘节点设备影响。</li>
        <li>共享线路，共享 IP 池。</li>
        <li>IP资源池 500w。</li>
        <li>支持 IP去重。</li>
        <li>
          关于提取不满的情况说明。由于中心是按需分配线路，存在当次分配线路时个别线路失败的情况。对于失败的线路就丢弃不分配，所以会存在实际提取不满的情况。成功率
          95%以上。
        </li>
        <li>支持企业定制化需求。</li>
      </ul>
    </div>
    <div class="item-desc">
      <p class="text1">验证方式</p>
      <ul>
        <li>提取时采用账密验证，通过验证才能正常调用接口。</li>
        <li>
          提取到分布式中心代理服务器的 IP以及代理端口，使用代理时采用
          IP白名单或者账密验证方式。
        </li>
      </ul>
    </div>
    <div class="item-desc">
      <p class="text1">功能接口</p>
      <ul>
        <li>
          提取接口：一次最多只能提取 200个，1 秒钟内只能调用 4
          次。可指定地区提取。
        </li>
        <li>查询账号可用 IP量接口：查询当前账号可提取 IP 量。</li>
      </ul>
    </div>
    <div class="item-desc">
      <p class="text1">适用场景</p>
      <dl class="d-flex">
        <dd>
          <img :src="require('@/assets/images/cpjs15.png')" alt="" />
          <span>数据采集</span>
        </dd>
        <dd>
          <img :src="require('@/assets/images/cpjs16.png')" alt="" />
          <span>搜索引擎优化(SEO)</span>
        </dd>
        <dd>
          <img :src="require('@/assets/images/cpjs17.png')" alt="" />
          <span>广告竞价和竞品监控</span>
        </dd>
      </dl>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
};
</script>

<style lang="less" scoped>
.cpjs {
  padding: 50px 0 116px;
  .item-desc {
    margin-bottom: 30px;
    p {
      color: #000;
      &.text1 {
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 6px;
      }
      &.text2 {
        font-size: 18px;
      }
    }
    ul {
      margin-left: 20px;
      li {
        list-style: disc;
        &::marker {
          color: #27a7e7;
          font-size: 24px;
        }
      }
    }
    dl {
      margin-top: 20px;
      dd {
        margin-right: 76px;
        img {
          margin-right: 10px;
        }
      }
    }
  }
  .cpjs-imgs {
    margin: 0 0 30px;
  }
}
@media (max-width: 768px) {
  .cpjs {
    padding: 4% 0;
  }
  .cpjs .item-desc {
    margin-bottom: 2%;
  }
  .cpjs .item-desc p.text1,
  .cpjs .item-desc ul li::marker {
    font-size: 16px;
  }
  .cpjs .item-desc p.text2,
  .cpjs .item-desc ul li {
    font-size: 14px;
  }
  .cpjs .item-desc dl {
    flex-wrap: wrap;
  }
  .cpjs .item-desc dl dd {
    font-size: 14px;
    margin-right: 0;
    width: 50%;
  }
}
@media (max-width: 375px) {
  .cpjs .item-desc dl dd {
    width: 100%;
  }
}
</style>
